import { createReducer, on } from '@ngrx/store'
import { Bank } from 'app/modules/products/_state/products.interfaces'
import * as bulkTopUpActions from './bulk-top-up.actions'
import { Country, Recipient, RecipientCategory, XcelAccount } from './bulk-top-up.interfaces'
export interface BulkTopUpState {
    countries: Country[] | null
    countriesError: boolean
    loadingCountries: boolean

    recipientCategories: RecipientCategory[] | null
    fetchRecipientCategoriesError: boolean
    loadingRecipientCategories: boolean

    pagination: { total: number; page: number; limit: number; totalPages: number };


    recipients: Recipient[] | null
    fetchRecipientsError: boolean
    loadingRecipients: boolean

    xcelAccount: XcelAccount | null
    validateXcelAccountError: boolean
    validatingXcelAccount: boolean

    categoryRecipients: Recipient[] | null
    fetchCategoryRecipientsError: boolean
    loadingCategoryRecipients: boolean

    accountBalance
    fetchAccountBalanceError: boolean
    loadingAccountBalance: boolean

    recipientBanks: Bank[] | null
    recipientBanksError: boolean
    recipientBanksLoading: boolean

}

export const initialState: BulkTopUpState = {
    countries:  null,
    countriesError: null,
    loadingCountries: null,

    recipientCategories: null,
    fetchRecipientCategoriesError: null,
    loadingRecipientCategories: null,

    pagination: { total: 0, page: 1, limit: 10, totalPages: 0 },

    recipients: null,
    fetchRecipientsError: null,
    loadingRecipients: null,

    xcelAccount:  null,
    validateXcelAccountError: null,
    validatingXcelAccount: null,

    categoryRecipients:  null,
    fetchCategoryRecipientsError: null,
    loadingCategoryRecipients: null,

    accountBalance: null,
    fetchAccountBalanceError: null,
    loadingAccountBalance: null,

    recipientBanks: null,
    recipientBanksError: null,
    recipientBanksLoading: null,
}

export const BulkTopUpReducer = createReducer(
    initialState,

    on(bulkTopUpActions.fetchCountries, (state) => ({
        ...state, countries: null, countriesError: null, loadingCountries: true
    })),

    on(bulkTopUpActions.fetchCountriesSuccess, (state, {countries}) => ({
        ...state, countries: countries, countriesError: false, loadingCountries: false
    })),

    on(bulkTopUpActions.fetchCountriesFailed, (state) => ({
        ...state, countries: null, countriesError: true, loadingCountries: false
    })),


    on(bulkTopUpActions.fetchRecipientCategories, (state) => ({
        ...state, recipientCategories: null, fetchRecipientCategoriesError: null, loadingRecipientCategories: true
    })),

        on(bulkTopUpActions.fetchRecipientCategoriesSuccess, (state, { recipientCategories, pagination }) => ({
            ...state,
            recipientCategories,
            pagination, 
            loadingRecipientCategories: false,
            fetchRecipientCategoriesError: false
          })),

    on(bulkTopUpActions.fetchRecipientCategoriesFailed, (state) => ({
        ...state, recipientCategories: null, fetchRecipientCategoriesError: true, loadingRecipientCategories: false
    })),


    
    on(bulkTopUpActions.fetchRecipients, (state) => ({
        ...state, recipients: null, fetchRecipientsError: null, loadingRecipients: true
    })),

    on(bulkTopUpActions.fetchRecipientsSuccess, (state, {recipients}) => ({
        ...state, recipients: recipients, fetchRecipientsError: false, loadingRecipients: false
    })),

    on(bulkTopUpActions.fetchRecipientsFailed, (state) => ({
        ...state, recipients: null, fetchRecipientsError: true, loadingRecipients: false
    })),


    on(bulkTopUpActions.validateXcelAccount, (state) => ({
        ...state, xcelAccount: null, validateXcelAccountError: null, validatingXcelAccount: true
    })),

    on(bulkTopUpActions.validateXcelAccountSuccess, (state, {xcelAccount}) => ({
        ...state, xcelAccount: xcelAccount, validateXcelAccountError: false, validatingXcelAccount: false
    })),

    on(bulkTopUpActions.validateXcelAccountFailed, (state) => ({
        ...state, xcelAccount: null, validateXcelAccountError: true, validatingXcelAccount: false
    })),


    on(bulkTopUpActions.fetchRecipientsByCategory, (state) => ({
        ...state, categoryRecipients: null, fetchCategoryRecipientsError: null, loadingCategoryRecipients: true
    })),

    on(bulkTopUpActions.fetchRecipientsByCategorySuccess, (state, {recipients}) => ({
        ...state, categoryRecipients: recipients, fetchCategoryRecipientsError: false, loadingCategoryRecipients: false
    })),

    on(bulkTopUpActions.fetchRecipientsByCategoryFailed, (state) => ({
        ...state, categoryRecipients: null, fetchCategoryRecipientsError: true, loadingCategoryRecipients: false
    })),



    on(bulkTopUpActions.fetchAccountBalance, (state) => ({
        ...state, accountBalance: null, fetchAccountBalanceError: null, loadingAccountBalance: true
    })),

    on(bulkTopUpActions.fetchAccountBalanceSuccess, (state, {balance}) => ({
        ...state, accountBalance: balance, fetchAccountBalanceError: false, loadingAccountBalance: false
    })),

    on(bulkTopUpActions.fetchAccountBalanceFailed, (state) => ({
        ...state, accountBalance: null, fetchAccountBalanceError: true, loadingAccountBalance: false
    })),


    on(bulkTopUpActions.fetchRecipientBanks, (state) => ({
        ...state, recipientBanks: null, recipientBanksError: null, recipientBanksLoading: true
    })),

    on(bulkTopUpActions.fetchRecipientBanksSuccess, (state, {banks}) => ({
        ...state, recipientBanks: banks, recipientBanksError: false, recipientBanksLoading: false
    })),

    on(bulkTopUpActions.fetchRecipientBanksFailed, (state) => ({
        ...state, recipientBanks: null, recipientBanksError: true, recipientBanksLoading: false
    })),


)